import React from 'react';
interface LayoutPickerProps {
  sectionType: 'listings-videos' | 'custom-links';
  selectedLayout: string;
  onLayoutChange: (layout: string) => void;
}
export function LayoutPicker({
  sectionType,
  selectedLayout,
  onLayoutChange
}: LayoutPickerProps) {
  if (sectionType === 'listings-videos') {
    const layouts = [{
      id: 'carousel',
      label: 'Carousel'
    }, {
      id: 'small-card',
      label: 'Small Cards'
    }, {
      id: 'large-card',
      label: 'Large Cards'
    }];
    return <div className="mb-4" data-id="element-195">
        <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-196">
          Layout
        </label>
        <div className="flex gap-3" data-id="element-197">
          {layouts.map(layout => <button key={layout.id} type="button" onClick={() => onLayoutChange(layout.id)} className={`flex-1 p-3 rounded-xl border-2 transition-all ${selectedLayout === layout.id ? 'border-brand-forest bg-brand-sage/30' : 'border-brand-light bg-white hover:border-brand-sage'}`} data-id="element-198">
              <div className="mb-2" data-id="element-199">
                {layout.id === 'carousel' && <div className="flex gap-1 justify-center" data-id="element-200">
                    <div className="w-8 h-10 bg-brand-light rounded" data-id="element-201"></div>
                    <div className="w-8 h-10 bg-brand-muted/20 rounded" data-id="element-202"></div>
                    <div className="w-8 h-10 bg-brand-muted/10 rounded" data-id="element-203"></div>
                  </div>}
                {layout.id === 'small-card' && <div className="grid grid-cols-2 gap-1" data-id="element-204">
                    <div className="h-8 bg-brand-light rounded" data-id="element-205"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-206"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-207"></div>
                    <div className="h-8 bg-brand-light rounded" data-id="element-208"></div>
                  </div>}
                {layout.id === 'large-card' && <div className="space-y-1" data-id="element-209">
                    <div className="h-6 bg-brand-light rounded" data-id="element-210"></div>
                    <div className="h-6 bg-brand-light rounded" data-id="element-211"></div>
                  </div>}
              </div>
              <p className="text-xs font-medium text-brand-dark text-center" data-id="element-212">
                {layout.label}
              </p>
            </button>)}
        </div>
      </div>;
  }
  const layouts = [{
    id: 'list',
    label: 'List (1 per row)'
  }, {
    id: 'grid',
    label: 'Grid (2 per row)'
  }];
  return <div className="mb-4" data-id="element-213">
      <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-214">
        Layout
      </label>
      <div className="flex gap-3" data-id="element-215">
        {layouts.map(layout => <button key={layout.id} type="button" onClick={() => onLayoutChange(layout.id)} className={`flex-1 p-3 rounded-xl border-2 transition-all ${selectedLayout === layout.id ? 'border-brand-forest bg-brand-sage/30' : 'border-brand-light bg-white hover:border-brand-sage'}`} data-id="element-216">
            <div className="mb-2" data-id="element-217">
              {layout.id === 'list' && <div className="space-y-1" data-id="element-218">
                  <div className="h-4 bg-brand-light rounded" data-id="element-219"></div>
                  <div className="h-4 bg-brand-light rounded" data-id="element-220"></div>
                  <div className="h-4 bg-brand-light rounded" data-id="element-221"></div>
                </div>}
              {layout.id === 'grid' && <div className="grid grid-cols-2 gap-1" data-id="element-222">
                  <div className="h-6 bg-brand-light rounded" data-id="element-223"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-224"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-225"></div>
                  <div className="h-6 bg-brand-light rounded" data-id="element-226"></div>
                </div>}
            </div>
            <p className="text-xs font-medium text-brand-dark text-center" data-id="element-227">
              {layout.label}
            </p>
          </button>)}
      </div>
    </div>;
}